import React, { useState } from "react";
// import ArrowIcon from "../../Images/HomePage/left-arrow.svg";
import ArrowIcon from "../../../../static/images/left-arrow.svg";
import XMark from "../../../../static/images/x-mark.svg";
// import XMark from "../../Images/x-mark.svg";
import Styles from "./index.module.scss";

export interface PhotoGalleryProps {
  id?: String;
  close: () => void;
}

function PhotoGallery({ id, close }: PhotoGalleryProps) {
  //   const { loading, error, data } = useQuery(GET_IMAGES, {
  //     variables: { id: id },
  //     skip: !id,
  //   });

  const [selected, setSelected] = useState(0);
  const [annimate, setAnnimate] = useState(false);

  class Carousel {
    images: String[];
    length: number;

    constructor(images: String[]) {
      this.images = images;
      this.length = images?.length;
    }
  }

  const user_images = [
    "https://res.cloudinary.com/dxuiu1h8i/image/upload/v1624423276/pachasi/Frame_10_ttszng.png",
    "https://res.cloudinary.com/dxuiu1h8i/image/upload/v1624423276/pachasi/Frame_11_mwoeae.png",
    "https://res.cloudinary.com/dxuiu1h8i/image/upload/v1624423276/pachasi/Frame_13_glsjlj.png",
    "https://res.cloudinary.com/dxuiu1h8i/image/upload/v1624423275/pachasi/Frame_12_jscx5x.png",
    "https://res.cloudinary.com/dxuiu1h8i/image/upload/v1624423276/pachasi/Frame_14_rlxj1c.png",
  ];
  const carousel = new Carousel(user_images);

  return (
    <div className={Styles.photoGalleryParentContainer}>
      <div className={Styles.photoGalleryContainer}>
        <div className={Styles.close}>
          <img src={XMark} alt="close" onClick={close} />
        </div>
        <h1>Some Trivial Info</h1>
        <div className={Styles.photoGalleryMainContainer}>
          <div
            className={Styles.leftButton}
            onClick={() => {
              if (selected > 0) {
                setSelected(selected - 1);
                setAnnimate(true);
              }
            }}
          >
            <img
              src={ArrowIcon}
              alt="back"
              className={Styles.backArrow}
              style={{
                visibility: selected > 0 ? "visible" : "hidden",
              }}
            />
          </div>
          <div
            className={`${Styles.left} ${annimate ? Styles.annimate : ""}`}
            onClick={() => {
              if (selected > 0) {
                setSelected(selected - 1);
                setAnnimate(true);
              }
            }}
            onAnimationEnd={() => setAnnimate(false)}
          >
            {selected > 0 && (
              <div
                className={`${annimate ? Styles.fadingEffect : ""} ${
                  Styles.photoGalleryImage
                }`}
                style={{
                  backgroundImage: `url(${carousel.images[selected - 1]})`,
                }}
              >
                <img src={ArrowIcon} alt="back" className={Styles.backArrow} />
              </div>
            )}
          </div>
          <div
            className={`${Styles.center} ${annimate ? Styles.annimate : ""}`}
          >
            <div
              className={Styles.photoGalleryImage}
              style={{
                backgroundImage: `url(${carousel.images[selected]})`,
              }}
            ></div>
          </div>
          <div
            className={Styles.leftButton}
            onClick={() => {
              if (selected < carousel.length - 1) {
                setSelected(selected + 1);
                setAnnimate(true);
              }
            }}
          >
            <img
              src={ArrowIcon}
              alt="back"
              className={Styles.nextArrow}
              style={{
                visibility:
                  selected < carousel.length - 1 ? "visible" : "hidden",
              }}
            />
          </div>
          <div
            className={`${Styles.right} ${annimate ? Styles.annimate : ""}`}
            onClick={() => {
              if (selected < carousel.length - 1) {
                setSelected(selected + 1);
                setAnnimate(true);
              }
            }}
            onAnimationEnd={() => setAnnimate(false)}
          >
            {selected < carousel.length - 1 && (
              <div
                className={`${annimate ? Styles.fadingEffect : ""} ${
                  Styles.photoGalleryImage
                }`}
                style={{
                  backgroundImage: `url(${carousel.images[selected + 1]})`,
                }}
              >
                <img src={ArrowIcon} alt="back" className={Styles.nextArrow} />
              </div>
            )}
          </div>
        </div>
        <div className={Styles.photoGalleryDots}>
          {carousel.images.map((_, index) => {
            return (
              <div
                key={index}
                onClick={() => setSelected(index)}
                className={`${Styles.photoGalleryDot} ${
                  selected === index ? Styles.selected : ""
                }`}
              ></div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default PhotoGallery;
